import { coercedDate } from '../../../utils/coerced-date';
import { z } from 'zod/v4';

export const ruleFieldsSchema = z.object({
  id: z.number().optional(),
  templateId: z.number(),
  parameters: z.array(
    z.object({
      id: z.number(),
      type: z.string(),
      value: z.string(),
      name: z.string().optional(),
      dataType: z.string().optional(),
    })
  ),
});

export const ruleSchema = ruleFieldsSchema.extend({
  templateName: z.string(),
  createdOn: coercedDate,
});

export type RuleFields = z.infer<typeof ruleFieldsSchema>;

export type Rule = z.infer<typeof ruleSchema>;
